import { createInstance } from "i18next";
import { initReactI18next } from "react-i18next";
import {
  DEFAULT_LANGUAGE,
  UI_LANGUAGES,
  readSavedUiLanguage,
} from "./languages";

// Yksi jaettu i18next-instanssi koko sovellukselle, myös React-portaaleille.
const i18n = createInstance();

i18n.use(initReactI18next).init({
  resources: Object.fromEntries(
    UI_LANGUAGES.map((item) => [item.code, item.resources])
  ),
  lng: readSavedUiLanguage(),
  fallbackLng: DEFAULT_LANGUAGE,
  supportedLngs: UI_LANGUAGES.map((item) => item.code),
  load: "languageOnly",
  ns: ["common", "admin"],
  defaultNS: "common",
  returnNull: false,

  // Käännökset ovat jo bundlessa: käynnistys ei tarvitse verkkopyyntöä.
  initImmediate: false,
  react: { useSuspense: false },
  interpolation: {
    // React suojaa JSX:n tekstiarvot. Käännöksiä ei syötetä raakaksi HTML:ksi.
    escapeValue: false,
  },
});

export default i18n;
